import React, { Suspense } from 'react';

export type MapProps = {
  lat: number;
  lng: number;
  premium?: boolean;
  zoom?: number;
  width?: string;
  height?: string;
};

export const Map: React.FunctionComponent<MapProps> = props => {
  const OpenStreetMap = React.lazy(() => import('./open-street-map.tsx'));
  const { lat, lng, premium = false, zoom = 17, width = '100%', height = '400px' } = props;

  return (
    <Suspense
      fallback={
        <div style={{ width, height }} className="animate-spin">
          Loading...
        </div>
      }
    >
      <OpenStreetMap
        center={[lat, lng]}
        zoom={zoom}
        width={width}
        height={height}
        markers={[
          {
            position: [lat, lng],
            premiumIcon: premium
          }
        ]}
      />
    </Suspense>
  );
};
